@if (show) {
  <div>
    <ngb-alert id="alert" [type]="alertType$ | async" (close)="closeAlert(alert)">
      {{message$ | async}}
    </ngb-alert>
  </div>
}
